export default function Dollars({ amount, withCents }) {
  // often the caller will do <Dollars>{amount}</Dollars>
  // this is wrong since we need the amoutn to determine the style.
  if (amount === undefined) throw new Error("Provide an amount attribute.")

  const digits = withCents ? 2 : 0
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: digits,
    minimumFractionDigits: digits
  }).format(amount)

  const textClass = amount >= 0 ? "text-success" : "text-danger text-nowrap"
  return <span className={textClass}>
    {formatted}
  </span>
}